import { Children, cloneElement } from "react";

export type AccordionProps = {
  children?: JSX.Element[] | JSX.Element;
  striped?: boolean;
  className?: string;
};

const Accordion = ({ children, striped, className }: AccordionProps) => {
  if (striped) {
    const basedChildren = Children.map(children, (child, index) => {
      if (child?.props) {
        return cloneElement(child, {
          ...child.props,
          className: (index + 1) % 2 && "bg-gray-200",
        });
      }
      return child;
    });

    return <div className={className}>{basedChildren}</div>;
  }

  return <div className={className}>{children}</div>;
};

export default Accordion;
